import React from 'react';
import PropTypes from 'prop-types';

import '../styles/SelectionTreeMenu.css';
import { findSelectionClassName } from '../helpers/helperFunctions.js';
import MenuHeader from './MenuHeader';

import {ReactComponent as BackIcon} from '../icons/back-icon.svg';
import {ReactComponent as CancelIcon} from '../icons/cancel-icon.svg';
import {ReactComponent as ArrowsUpDownIcon} from '../icons/arrow-up-down-icon.svg';
import {ReactComponent as ArrowsLeftRightIcon} from '../icons/arrow-left-right-icon.svg';
import {ReactComponent as SetIcon} from '../icons/set-icon.svg';


const icons = {
  back: <BackIcon className="Icon-topbar" />,
  cancel: <CancelIcon className="Icon-topbar" />,
  arrowsUpDown: <ArrowsUpDownIcon className="Icon-topbar" />,
  arrowsLeftRight: <ArrowsLeftRightIcon className="Icon-topbar" />,
  setIcon: <SetIcon className="Icon-topbar" />,
}

const SelectionTreeMenu = ({
    name, settings, index, indexChild
  }) => {
    const selectionIndex = index;
    const optionIndex = indexChild;
    const select = optionIndex === null ? <>{icons.arrowsUpDown} Move cursor</> : <>{icons.arrowsLeftRight} Select</>;
    const set = optionIndex === null ? 'Change' : 'Set';
    const cancel = optionIndex === null ? icons.back : 'Cancel';
    const currentTitle = selectionIndex === 0 && optionIndex !== null ? '---' : settings.title;
    return (
      <>
        <MenuHeader itemName={name} />
  
        <div className="Selection-tree-container">

            <div className="Selection-tree-elements">
                <div className="Selection-tree-title">{currentTitle}</div>
        
                <div className="Selection-main-options">
                    <div className="Selection-lists-container">
                    {settings.options.map((selection, index, array) => {
                    const selectionClassName = findSelectionClassName(index, array.length, selectionIndex, optionIndex);
                    const currentOptionIndex = index === selectionIndex && optionIndex !== null ? optionIndex : 0;
                    let selectionElement;

                    if (index === 0) {
                        selectionElement = <div key={index} className={selectionClassName}>{selection[currentOptionIndex]}</div>;
                    } else {
                        const elementName = selectionIndex === 0 && optionIndex !== null ? 'LUT: ---' : selection[currentOptionIndex];
                        selectionElement = <div key={index} className={selectionClassName}>{elementName}</div>;
                    }

                    return selectionElement;
                    })}
                    </div>
                    </div>
                
                <div className="Selection-side-options">
                    {settings.settings.map(option => <div key={option} className="Selection-side-option">{option}</div>)}
                </div>
            </div>
        
            <div className="Options-buttons-container">
                <div>{select}</div>
                <div>{icons.setIcon}{set}</div>
                <div>{icons.cancel}{cancel}</div>
            </div>
        </div>
      </>
    );
  };
  
SelectionTreeMenu.propTypes = {
    name: PropTypes.string.isRequired,
    settings:  PropTypes.object.isRequired,
    index: PropTypes.number.isRequired,
    indexChild: PropTypes.number,
};

export default SelectionTreeMenu;